<template>
  <div class="template-body">
    <!--面包屑部分-->
    <div class="ccui-navigation" ref="noPrintTop">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="purchaseBack"
        >返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: '/electronicQuotation/electronicQuotationLists' }"
          >电子报价
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/electronicQuotation/electronicQuotationLists' }"
          >报价
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/electronicQuotation/electronicQuotationLists' }"
          >询价报价
        </el-breadcrumb-item>
        <el-breadcrumb-item
          >查看
          <span class="ccui-curr-crumb ccui-ml-10">{{
            detailsLists.seekCode
          }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--主体部分-->
    <div class="detail-box ccui-clearfix">
      <div class="detail-info">
        <img
          v-if="detailsLists.seekType === 4"
          :src="require('../electronicQuotationLists/img/cancel.png')"
          style="width: 140px;height: 140px;position: absolute;right: 0;z-index: 1"
          alt=""
        />
        <div style="display: flex;background: #EBEBEB;position: relative">
          <div
            class="tab"
            @click="tabChange(item)"
            v-for="item in tabButton"
            :key="item.focus"
            :class="tabShow === item.value ? 'table-top-active' : 'table-top'"
          >
            {{ item.label }}
          </div>

          <div
            v-if="detailsLists.seekType === 3"
            style="position: absolute;right: -11px;top:29px"
          >
            <img
              v-if="
                detailsLists.seekSupplier.isChecked &&
                  detailsLists.approvalStatus === 2
              "
              style="width: 120px"
              src="./img/select.png"
              alt=""
            />
            <img v-else style="width: 120px" src="./img/unSelect.png" alt="" />
          </div>
        </div>
        <div style="margin-top: 20px" v-if="tabShow === 1">
          <detailShow :baseInfo="baseInfo" :detailInformation="detailsLists" />
          <el-row>
            <el-col v-if="detailsLists.seekType === 4" span="24">
              <div class="info-item">
                <span class="label">取消原因:</span>
                <span>{{ detailsLists.cancelReason }}</span>
              </div>
            </el-col>
          </el-row>
          <el-card-title
            title="交货及交付"
            v-if="detailsLists.sourceSystem !== 2"
            style="margin-bottom: 20px"
            class="detail-info-form-title"
          ></el-card-title>
          <detailShow
            v-if="detailsLists.sourceSystem !== 2"
            :baseInfo="delivery"
            :detailInformation="detailsLists"
          />

          <el-row>
            <el-col>
              <div class="info-item">
                <span class="label">付款条件:</span>
                <div style="display: flex;flex-direction: column">
                  <div
                    v-for="(item, index) in detailsLists.payTypeBOList"
                    :key="index"
                  >
                    <el-radio
                      style="margin-bottom: 10px"
                      disabled
                      v-model="item.payType"
                      label="1"
                      >{{ payTypeChange(item.payType) }}
                    </el-radio>
                    <el-table
                      ref="detailsListsTable"
                      :data="item.payTypeItemList"
                      style="margin-bottom: 20px; width: 100%"
                      border
                    >
                      <el-table-column
                        label="支付次数"
                        :show-overflow-tooltip="true"
                        prop="payRecords"
                        fixed="left"
                        align="left"
                        min-width="50"
                      >
                      </el-table-column>
                      <el-table-column
                        align="left"
                        label="规定时间"
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{
                              fixTimeCodeChange(scope.row.fixTimeCode) +
                                scope.row.fixTimeLength +
                                textShow(scope.row.fixTimeCode, scope.row)
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="left"
                        label="付款方式"
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <el-radio
                            disabled
                            v-model="scope.row.payTypeCode"
                            label="1"
                            >{{ payTypeCodeChange(scope.row.payTypeCode) }}
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="left"
                        label="付款比率"
                        min-width="160"
                      >
                        <template slot-scope="scope">
                          <div style="display: flex;align-items: center">
                            <span> 付{{ scope.row.payRate }}%</span>
                            <el-radio
                              v-if="
                                scope.row.isRetentionMoney === 0 ||
                                  scope.row.isRetentionMoney === 1
                              "
                              disabled
                              label="1"
                              >{{
                                isRetentionMoneyChange(
                                  scope.row.isRetentionMoney
                                )
                              }}
                            </el-radio>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-card-title
            title="配送信息"
            style="margin-bottom: 20px"
            class="detail-info-form-title"
          ></el-card-title>
          <detailShow
            :baseInfo="distribution"
            :detailInformation="detailsLists"
          />
        </div>
        <div style="margin-top: 20px" v-if="tabShow === 2">
          <div
            style="border-bottom: 1px solid #D8D8D8;margin: 0 20px;padding: 0 10px;position: relative"
          >
            <h2
              style="font-weight: 600;font-size: 20px;color: #4A4A4A;margin-bottom: 20px"
            >
              {{ detailsLists.sourceSystem == 1 ? "" : "询价标题：" }}
              {{ detailsLists.seekTitle }}
            </h2>
            <div class="bodyText">
              <span class="bodyTextPadding"
                >{{
                  detailsLists.sourceSystem == 1 ? "开始时间" : "询价开始时间"
                }}
                ：{{ detailsLists.seekStartTime }}</span
              >
              <span class="bodyTextPadding"
                >{{
                  detailsLists.sourceSystem == 1 ? "截止时间" : "询价截止时间"
                }}
                ：{{ detailsLists.seekOffTime }}</span
              >
              <!--            <span class="bodyTextPadding">邀请供应商数量：4</span>-->
              <!--            <span>报价供应商数量：3</span>-->
            </div>
            <!--          <div class="bodyText">-->
            <!--            确认原因：航科物流公司为最低价，且合作过多次。-->
            <!--          </div>-->
            <div
              class="quotation"
              v-if="
                detailsLists.seekSupplier.quoteType === 1 ||
                  (detailsLists.seekSupplier.quoteType === 2 &&
                    this.detailsLists.isOff === 0)
              "
            >
              <div class="time">
                <span>{{ remainingTime.hours }}</span
                >小时<span>{{ remainingTime.minutes }}</span
                >分钟<span>{{ remainingTime.seconds }}</span
                >秒
              </div>
              <span
                >{{
                  detailsLists.sourceSystem == 1 ? "" : "询价"
                }}
                剩余时间</span
              >
            </div>
            <div v-else class="quotation">
              <div class="time">
                <span>00</span>小时<span>00</span>分钟<span>00</span>秒
              </div>
              <span>询价剩余时间</span>
            </div>
          </div>
          <div style="padding: 0 20px">
            <el-card-title
              title="商品清单"
              style="margin:0;margin-bottom: 20px"
              class="detail-info-form-title"
            ></el-card-title>
            <div v-if="detailsLists.propBrandNames" class="goodsDetail">
              <!--          新增的东西-->
              <span>可供品牌：{{ detailsLists.propBrandNames }}</span>
            </div>

            <el-table
              ref="detailsListsTable"
              :data="detailsLists.seekSupplierQuoteDetails"
              style="margin-bottom: 20px; width: 100%"
              border
              :summary-method="getSummaries"
              :cell-style="tableCellStyle"
              :header-cell-style="headerCellStyle"
              show-summary
            >
              <!-- 序号列 -->
              <el-table-column
                fixed="left"
                label="序号"
                type="index"
                width="50"
              />

              <!-- 商品名称 -->
              <el-table-column
                label="商品名称"
                :show-overflow-tooltip="true"
                fixed="left"
                align="left"
                min-width="278px"
              >
                <template v-slot="scope">
                  <div>
                    {{ detailsLists.sourceSystem == 1 ? "" : "商品名称：" }}
                  </div>
                  <div>{{ scope.row.skuName }}</div>
                  <div v-if="!detailsLists.propBrandNames">
                    品牌：{{ scope.row.brandName }}
                  </div>
                  <div>计量单位：{{ scope.row.unitName }}</div>
                </template>
              </el-table-column>

              <!-- 数量/重量 -->
              <el-table-column
                align="left"
                prop="purchaseCount"
                label="数量/重量"
                min-width="80px"
              />
              <el-table-column
                v-for="item in tableColumn"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                :align="
                  item.prop === 'pricingMethodsName' ||
                  item.prop === 'rentalTime'
                    ? 'left'
                    : 'right'
                "
                :fixed="item.prop === 'subtotal' ? 'right' : false"
                header-align="left"
                min-width="120px"
              >
                <template
                  v-if="
                    item.prop === 'fixedUnitPrice' ||
                      item.prop === 'freight' ||
                      item.prop === 'taxIncludePrice' ||
                      item.prop === 'installFee'
                  "
                  slot="header"
                >
                  <span style="display: flex;align-items: center">
                    <span style="color: red">*</span>
                    <span>{{ item.label }}</span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content">
                        <div>
                          发货地：
                          {{
                            detailsLists.freightBO &&
                            detailsLists.freightBO.startAddress
                              ? detailsLists.freightBO.startAddress.addressAll
                              : "暂无"
                          }}
                        </div>
                        <div>
                          交货地：
                          {{
                            detailsLists.freightBO &&
                            detailsLists.freightBO.endAddress
                              ? detailsLists.freightBO.endAddress.addressAll
                              : "暂无"
                          }}
                        </div>
                        <div>
                          距离：
                          {{
                            detailsLists.freightBO
                              ? detailsLists.freightBO.distance
                              : "0"
                          }}公里
                        </div>
                      </div>
                      <img
                        style="margin-left: 8px"
                        v-if="item.prop === 'freight'"
                        src="./img/bgWarning.png"
                        alt=""
                      />
                    </el-tooltip>
                  </span>
                </template>
                <template v-slot="scope">
                  <!--                  第一层判断：isSkuAttr判断是左边（只需要显示的）还是右边（有需要编辑的），这里是属于右边的逻辑-->
                  <div
                    v-if="!$route.query.type && isSkuAttr(scope.row, item.prop)"
                  >
                    <!--                    第二层判断：isInputExist判断商品是不是存在这个表头，不存在就显示-，例如：可能第一条数据有最终报价，第二条数据没有，-->
                    <!--                    isInputDis判断是否可以编辑，在判断完是属于右边后有些数据是不允许被编辑的，
                        例如：第一条数据的最终报价可以修改，第二条不让修改，
                        所以必须满足当行表头数据存在且可以编辑才显示输入框-->
                    <el-input
                      v-if="
                        isInputExist(scope.row, item.prop) &&
                          isInputDis(scope.row, item.prop)
                      "
                      v-model="scope.row[item.prop]"
                      @input="handleInput(scope.row, item.prop)"
                      @blur="handleBlur(scope.row, item.prop)"
                      :placeholder="`请输入${item.label}`"
                    />
                    <!--                    第二层判断：当行表头数据存在且不可以被编辑的时候直接显示金额就可以-->
                    <span
                      v-else-if="
                        isInputExist(scope.row, item.prop) &&
                          !isInputDis(scope.row, item.prop)
                      "
                      >{{ scope.row[item.prop].toFixed(2) }}
                    </span>
                    <!--                    第二层判断：上面两条都不满足的情况下显示-  -->
                    <span v-else>-</span>
                  </div>
                  <!--                  第一层判断：这里是属于左边的逻辑，如果是左边的就是只读状态，isInputExist判断存在显示数字保留两位小数，
                      不存在现实- -->
                  <span v-else>
                    {{
                      isInputExist(scope.row, item.prop)
                        ? showChange(item.prop, scope.row[item.prop])
                        : "-"
                    }}
                  </span>
                </template>

                <!--                <template-->
                <!--                  v-if="-->
                <!--                    (!$route.query.type && item.isEditable) ||-->
                <!--                      (!$route.query.type &&-->
                <!--                        item.isEditable &&-->
                <!--                        item.prop === 'comprehensiveUnitPrice') ||-->
                <!--                      (!$route.query.type &&-->
                <!--                        item.isEditable &&-->
                <!--                        item.prop === 'subtotal') ||-->
                <!--                      (!$route.query.type &&-->
                <!--                        item.isEditable &&-->
                <!--                        item.prop === 'quoteSolidContentRatio')-->
                <!--                  "-->
                <!--                  v-slot="scope"-->
                <!--                >-->
                <!--                  <el-input-->
                <!--                    v-model="scope.row[item.prop]"-->
                <!--                    :disabled="-->
                <!--                      item.prop === 'comprehensiveUnitPrice' ||-->
                <!--                        item.prop === 'subtotal' ||-->
                <!--                        item.prop === 'quoteSolidContentRatio'-->
                <!--                    "-->
                <!--                    @input="handleInput(scope.row, item.prop)"-->
                <!--                    @blur="handleBlur(scope.row, item.prop)"-->
                <!--                    :placeholder="`请输入${item.label}`"-->
                <!--                  />-->
                <!--                </template>-->
              </el-table-column>
              <!--              新增的东西-->
              <el-table-column
                v-if="detailsLists.propBrandNames"
                align="left"
                label="报价商品"
                min-width="200px"
              >
                <template v-slot="scope">
                  <span
                    :class="scope.row.newSkuName ? 'newSkuNameGo' : ''"
                    @click="goGoodsDetail(scope.row)"
                    v-if="$route.query.type === 'detail'"
                    >{{
                      scope.row.newSkuName ? scope.row.newSkuName : "-"
                    }}</span
                  >
                  <div v-else>
                    <span
                      @click="handleGoods(scope.row)"
                      :class="scope.row.newSkuName ? 'fineText' : 'blodText'"
                      >{{ scope.row.newSkuName || "关联报价商品" }}</span
                    >
                    <i
                      v-if="scope.row.newSkuName"
                      @click="deleteSkuName(scope.row)"
                      class="el-icon-error"
                      style="font-size: 18px;cursor:pointer;position: absolute;top: 5px;right: 5px;"
                    ></i>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                v-if="detailsLists.propBrandNames"
                align="left"
                prop="newSkuPropBrand"
                label="报价品牌"
                min-width="200px"
              >
                <template slot="header">
                  <span style="color: red">*</span>
                  <span>报价品牌</span>
                </template>
                <template v-slot="scope">
                  <span v-if="$route.query.type === 'detail'">{{
                    scope.row.newSkuPropBrand ? scope.row.newSkuPropBrand : "-"
                  }}</span>
                  <el-select
                    v-else
                    v-model="scope.row.newSkuPropBrand"
                    placeholder="请选择"
                    @focus="loadBrandOptions(scope.row)"
                    @change="val => loadBrandOptionsChange(val, scope.row)"
                  >
                    <el-option
                      v-for="item in brandOptionsMap[scope.row.seekSkuId] || []"
                      :key="item.tskuId"
                      :label="item.brandName"
                      :value="item.brandName"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
            <!--            新增的东西-->
            <goodsDialog
              ref="goodsDialog"
              :goodsDialogVisible="goodsDialogVisible"
              :propBrandNames="brandOptionsMap[goodsSelect.seekSkuId]"
              @handleDialogSubmit="handleDialogSubmit"
              @handleDialogCancel="handleDialogCancel"
            />
            <!--            附件-->
            <div style="position: relative">
              <el-card-title
                :title="
                  detailsLists.sourceSystem == 1 ? '报价文件' : '上传报价文件'
                "
                style="margin:0;margin-bottom: 20px"
                class="detail-info-form-title"
              ></el-card-title>
              <span
                style="position: absolute;top: 12px;left: 100px;font-size: 13px;color: #9B9B9B"
                >{{
                  detailsLists.sourceSystem == 1
                    ? "支持上传多份文件，每份大小控制在50M以内"
                    : "若有详细报价说明文件，可上传。附件大小需控制在50M以内，支持上传多份附件"
                }}</span
              >
              <div
                class="extend-btn"
                v-if="
                  detailsLists.seekSupplier.quoteType === 1 ||
                    (detailsLists.seekSupplier.quoteType === 2 &&
                      detailsLists.isOff === 0 &&
                      !$route.query.type)
                "
              >
                <el-upload
                  class="upload-demo tow"
                  accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png, .bmp, .jpeg"
                  :action="uploadUrl"
                  multiple
                  :on-remove="handleRemove"
                  :on-success="uploadHandler"
                  :on-error="uploadError"
                  :before-upload="beforeUpload"
                  :on-progress="onProgress"
                  :headers="headers"
                  :show-file-list="false"
                  ref="uploadItem"
                >
                  <el-button
                    type="text"
                    style="color: #0089EF;border: 1px solid #0089EF;font-size: 13px;border-radius: 0;padding: 6px 9px;position: absolute;top: 20%;right: 0"
                    >上传文件
                  </el-button>
                </el-upload>
              </div>
            </div>
            <el-table
              :data="detailsLists.seekFiles"
              style="margin-bottom:20px;width: 100%"
              border
            >
              <el-table-column
                fixed="left"
                label="序号"
                type="index"
                width="50"
              />
              <el-table-column
                prop="fileName"
                label="附件名称"
                align="left"
                :show-overflow-tooltip="true"
                min-width="200px"
              />
              <el-table-column
                align="left"
                prop="fileSize"
                label="附件大小"
                min-width="100px"
              />

              <el-table-column
                prop="fileRemark"
                label="附件说明"
                align="left"
                min-width="230px"
              >
                <template
                  v-if="
                    detailsLists.seekSupplier.quoteType === 1 ||
                      (detailsLists.seekSupplier.quoteType === 2 &&
                        detailsLists.isOff === 0 &&
                        !$route.query.type)
                  "
                  v-slot="scope"
                >
                  <el-input v-model="scope.row.fileRemark" placeholder="" />
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="上传时间"
                align="left"
                min-width="150px"
              />
              <el-table-column label="操作" align="left" width="150px">
                <template v-slot="scope">
                  <el-button
                    size="mini"
                    v-for="e in accessoryOptions(scope.row)"
                    :key="e.value"
                    type="text"
                    @click="handleClick(scope.row, e.value)"
                  >
                    {{ e.label }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="font-weight: 400;font-size: 13px;color: #4A4A4A;display: flex"
            >
              <span style="white-space: nowrap;">报价说明：</span>
              <el-input
                v-if="
                  detailsLists.seekSupplier.quoteType === 1 ||
                    (detailsLists.seekSupplier.quoteType === 2 &&
                      detailsLists.isOff === 0 &&
                      !$route.query.type)
                "
                type="textarea"
                v-model="detailsLists.seekSupplier.quoteDescription"
                maxlength="500"
                show-word-limit
                :rows="5"
              ></el-input>
              <div v-else>{{ detailsLists.seekSupplier.quoteDescription }}</div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :width="dialogTitle === '库存预警' ? '60%' : '478px'"
        max-height="400px"
        :before-close="handleClose"
      >
        <div v-if="dialogTitle === '库存预警'" style="padding: 20px 0">
          <span style="font-size: 13px;color: #FF142F"
            >商品库存不足，请核实并及时补足库存，以确保供货无忧！</span
          >
          <el-table
            ref="dialogDetailsListsTable"
            :data="seekSkuReqBOList"
            style="width: 100%"
            border
            class="detailsListsTable"
          >
            <el-table-column label="商品信息" align="left" width="130px">
              <template v-slot="scope">
                <div>商品名称：</div>
                <div>{{ scope.row.skuName }}</div>
                <div>品牌：{{ scope.row.brandName }}</div>
                <div>计量单位：{{ scope.row.unitName }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="purchaseCount"
              label="数量/重量"
              align="left"
              width="130px"
            />
            <el-table-column
              prop="stockNum"
              label="库存数量"
              align="left"
              width="130px"
            />
          </el-table>
        </div>
        <div v-else class="dialogBody">
          <div>本次报价总金额(CNY-人民币)：{{ aggregateAmount }}</div>
          <div>大写金额： {{ numberToChinese(aggregateAmount) }}</div>
          <div>您是否确认提交？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogSubmit(dialogTitle)"
            >确 认</el-button
          >
        </span>
      </el-dialog>

      <!--底部功能按钮-->
      <el-bottom-guide>
        <ul class="ccui-bottom-button" ref="noPrintBottom">
          <li>
            <el-button
              type="bottom"
              icon="icon-ccui-return"
              @click="purchaseBack"
              >返回
            </el-button>
          </li>
          <div
            v-if="
              detailsLists.seekSupplier &&
                filteredOptions(detailsLists).length > 0 &&
                $route.query.type != 'detail'
            "
            class="ccui-bottom-guide-divider"
          />
          <li
            style="display: flex;align-items: center"
            v-for="item in filteredOptions(detailsLists)"
            :key="item.value"
          >
            <el-button
              v-if="$route.query.type != 'detail'"
              type="bottom"
              @click="handlePurchase(item.label)"
            >
              <div style="display: flex;align-items: center">
                <img
                  v-if="
                    item.img && item.label === '提交报价' && !$route.query.type
                  "
                  style="width: 16px;height: 16px"
                  :src="item.img"
                  alt=""
                />
                <div style="margin-left: 5px">
                  {{ item.label }}
                </div>
              </div>
            </el-button>
            <!--            <img-->
            <!--              v-if="item.label === '提交报价' && !$route.query.type"-->
            <!--              style="width: 16px;height: 16px"-->
            <!--              :src="item.img"-->
            <!--              alt=""-->
            <!--            />-->
            <!--            <el-button-->
            <!--              v-if="item.label === '提交报价' && !$route.query.type"-->
            <!--              type="bottom"-->
            <!--              @click="handlePurchase(item.label)"-->
            <!--            >-->
            <!--              {{ item.label }}-->
            <!--            </el-button>-->
          </li>
        </ul>
      </el-bottom-guide>
    </div>
  </div>
</template>
<script>
import detailShow from "./components/detailShow.vue";
import Cookies from "js-cookie";
import {
  querySeekDetailForSupplierDetail,
  querySeekSkuForSupplier,
  supplierQuote,
  getShowPrice,
  getShowFinalQuotePrice,
  supplierRegister,
  querySeekDetailBySkuIdForSupplier,
  queryPropBrandValuesByClassifyCodeAndTskuId
} from "@/app/electronicQuotation/api/all";
import { addUrlPerFix } from "@/config/utils";
import goodsDialog from "./components/goodsDialog.vue";
// import { deleteAppUser } from "@/app/applicationSettings/api/powerManage";

const VUE_APP_UPLOAD_URL = addUrlPerFix(process.env.VUE_APP_UPLOAD_URL);

export default {
  components: {
    detailShow,
    goodsDialog
  },
  data() {
    return {
      brandOptionsMap: {},
      uploadUrl: VUE_APP_UPLOAD_URL, // 上传地址

      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      accessoryButton: [
        {
          value: 1,
          label: "下载"
        },
        {
          value: 2,
          label: "预览"
        },
        {
          value: 3,
          label: "删除"
        }
      ],
      remainingTime: {
        hours: "00",
        minutes: "00",
        seconds: "00"
      },
      optionButton: [
        {
          value: 1,
          label: "提交报价",
          img: require("./img/submat.png")
        }
      ],
      detailsLists: {
        seekSupplier: {
          quoteType: null
        }
      },
      tabShow: 1,
      seekSkuReqBOList: [], //库存预警
      tabButton: [
        {
          value: 1,
          label: "基本信息"
        },
        {
          value: 2,
          label: "报价信息"
        }
      ],
      // 基本信息
      baseInfo: [
        {
          value: "schemeTypeName",
          label: "方案类型",
          row: 12,
          isShow: false
        },
        // {
        //   value: "planName",
        //   label: "计划名称",
        //   row: 12,
        //   isShow: false
        // },
        // {
        //   value: "planCode",
        //   label: "计划编号",
        //   row: 12,
        //   isShow: false
        // },
        {
          value: "doDeptName",
          label: "经办单位",
          row: 12,
          isShow: false
        },
        {
          value: "doDeptName",
          label: "经办单位/部门",
          row: 12,
          isShow: true
        },
        {
          value: "purchaseOrgName",
          label: "采购单位",
          row: 12,
          isShow: true
        },
        {
          value: "doUnitUserName",
          label: "采购经办人",
          row: 12,
          isShow: true
        },
        {
          value: "doUnitUserPhone",
          label: "采购经办人手机号",
          row: 12,
          isShow: false
        },
        {
          value: "seekTitle",
          label: "询价标题",
          row: 12,
          isShow: true
        },
        {
          value: "seekCode",
          label: "询价单号",
          row: 12,
          isShow: true
        },
        {
          value: "seekStartTime",
          label: "询价开始时间",
          row: 12,
          isShow: true
        },
        {
          value: "seekOffTime",
          label: "询价截止时间",
          row: 12,
          isShow: true
        },
        // 新增的东西
        {
          value: "purchaseMethod",
          label: "采购方式",
          row: 12,
          isShow: true,
          type: "purchaseMethod"
        },
        {
          value: "purchaseRequestDescription",
          label: "采购申请说明",
          row: 24,
          isShow: true
        }
      ],
      // 交货
      delivery: [
        {
          value: "paymentMethod",
          label: "付款方式",
          row: 12,
          type: "paymentMethod",
          isShow: true
        },
        {
          value: "invoiceType",
          label: "发票类型",
          row: 12,
          type: "invoiceType",
          isShow: true
        },
        {
          value: "invoiceAgreement",
          label: "开票约定",
          row: 12,
          isShow: true
        },
        {
          value: "transportationMethod",
          label: "运输方式",
          row: 12,
          type: "transportationMethod",
          isShow: true
        },
        {
          value: "deliveryMethod",
          label: "交货方式",
          row: 12,
          type: "deliveryMethod",
          isShow: true
        },
        // 新增的东西
        {
          value: "inquiryMode",
          label: "询价模式",
          row: 12,
          isShow: true,
          type: "inquiryMode"
        },
        {
          value: "pricingDate",
          label: "定价日期",
          row: 12,
          isShow: true,
          type: "pricingDate"
        }
        // {
        //   value: "paymentTerms",
        //   label: "付款条件",
        //   row: 24,
        //   isShow: true
        // }
      ],
      // 配送
      distribution: [
        {
          value: "requiredDeliveryDate",
          label: "要求到货日期",
          row: 12,
          format: "time",
          isShow: true
        },
        {
          value: "deliveryTime",
          label: "配送时间",
          row: 12,
          type: "deliveryTime",
          isShow: true
        },
        {
          value: "receiverName",
          label: "收货人信息",
          row: 12,
          isShow: true
        },
        {
          value: "deliveryRequirements",
          label: "送货要求",
          row: 24,
          isShow: true
        },
        {
          value: "projectName",
          label: "项目名称",
          row: 24,
          isShow: true
        }
      ],
      quoteDescription: "", //报价说明
      dialogTitle: "",
      dialogVisible: false,
      aggregateAmount: null,
      // 商品动态表格
      tableColumn: [],
      brandsLists: [],
      goodsDialogVisible: false,
      goodsSelect: []
    };
  },
  created() {
    if (this.$route.query.status === 2) {
      supplierRegister({
        seekId: this.$route.params.id,
        seekSupplierId: this.$route.params.seekSupplierId
      }).then(res => {
        if (res.data.code == "0") {
          this.getInit();
        }
      });
    }
    this.getInit();
  },
  activated() {
    const savedTab = localStorage.getItem("currentTab");
    this.tabShow = savedTab ? Number(savedTab) : 2;
    this.getInit();
  },
  computed: {
    // brandsShow() {
    //   console.log(this.detailsLists.propBrandNames,23123212)
    //   // if (this.detailsLists.propBrandNames&&!this.detailsLists.propBrandNames.length) return ''
    //   // const brandNames = this.detailsLists.propBrandNames.map(item => item.brandNames)
    //   // return brandNames.join('，')
    // }
  },
  methods: {
    loadBrandOptions(row) {
      const key = row.seekSkuId;
      try {
        queryPropBrandValuesByClassifyCodeAndTskuId({
          classifyCode: row.caterycode,
          tskuId: row.tskuId,
          brands: this.detailsLists.propBrandNames
        }).then(res => {
          if (res.data.code == 0) {
            this.$set(this.brandOptionsMap, key, res.data.data || []);
          }
        });
      } catch (e) {
        console.error("品牌列表获取失败", e);
        this.$set(this.brandOptionsMap, key, []);
      }
    },
    loadBrandOptionsChange(val, row) {
      const options = this.brandOptionsMap[row.seekSkuId] || [];
      const match = options.find(e => e.brandName === val);

      if (match) {
        this.detailsLists.seekSupplierQuoteDetails.forEach(item => {
          if (item.seekSkuId === row.seekSkuId) {
            item.tskuId = match.tskuId;
          }
        });
        querySeekDetailBySkuIdForSupplier({
          skuId: row.skuId,
          seekId: this.detailsLists.seekId,
          seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId,
          isShowLoading: true
        }).then(res => {
          if (res.data.code == 0) {
            let arr = res.data.data.seekSupplierQuoteDetails[0];
            this.detailsLists.seekSupplierQuoteDetails = this.detailsLists.seekSupplierQuoteDetails.map(
              item => {
                if (item.skuId === arr.skuId) {
                  item.dynamicFields.map(e => {
                    if (e.isSkuAttr) {
                      console.log(item[e.prop], arr[e.prop]);
                      item[e.prop] = arr[e.prop];
                    }
                  });
                  // item.newSkuPropBrand = arr.propBrandName;
                  item.newSkuName = "";
                  item.newSkuId = "";
                }
                return item;
              }
            );
          }
        });
      }
    },
    getInit() {
      querySeekDetailForSupplierDetail({
        seekId: this.$route.params.id,
        seekSupplierId: this.$route.params.seekSupplierId,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          const allDynamicFields = res.data.data.dynamicFields.find(
            item => item.key === "all"
          );
          if (allDynamicFields) {
            // 确保动态列唯一
            this.tableColumn = allDynamicFields.value.reduce((unique, item) => {
              if (!unique.find(col => col.prop === item.prop)) {
                unique.push(item);
              }
              return unique;
            }, []);
          }
          this.detailsLists = res.data.data;
          //商品品牌
          this.getBrands();
          const isSourceSystem2 = this.detailsLists.sourceSystem === 2;

          this.baseInfo = this.baseInfo.map(item => {
            if (
              ["schemeTypeName", "planName", "planCode"].includes(item.value) ||
              item.label === "经办单位"
            ) {
              return {
                ...item,
                isShow: isSourceSystem2
              };
            }

            if (item.label === "经办单位/部门") {
              return {
                ...item,
                isShow: !isSourceSystem2
              };
            }
            return item;
          });
          this.startCountdown();
        }
      });
    },
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log(column,123123123)
      // row.dynamicFields = row.dynamicFields.filter(item =>
      //     !(item.prop === 'taxIncludePrice' && item.isEditable && !item.isSkuAttr)
      // );
      if (rowIndex >= 0 && !this.isSummaryRow(row)) {
        const matchedFields = row.dynamicFields.filter(
          item => item.isSkuAttr && item.prop === column.property
        );
        if (
          matchedFields.length > 0 ||
          column.label === "商品名称" ||
          column.label === "数量/重量"
        ) {
          return { backgroundColor: "#f5f5f5" };
        }
      }
      return {};
    },
    headerCellStyle({ column }) {
      if (column.label === "最终报价(元)") {
        return { fontSize: "15px" };
      }
      return {};
    },
    isSummaryRow(row) {
      // 判断是否为汇总行
      return row.hasOwnProperty("isSummary") && row.isSummary;
    },
    getBrands() {
      if (this.detailsLists.propBrandNames) {
        this.brandsLists = this.detailsLists.propBrandNames.split(",");
        this.detailsLists.seekSupplierQuoteDetails = this.detailsLists.seekSupplierQuoteDetails.map(
          item => {
            let newSkuName = item.skuName;
            if (item.propBrandName && item.skuName) {
              const reg = new RegExp(item.propBrandName, "g");
              newSkuName = item.skuName.replace(reg, "");
            }
            return {
              ...item,
              skuName: newSkuName
            };
            // return {
            //   ...item,
            //   newSkuPropBrand: item.propBrandName
            // };
          }
        );
      }

      // let arr= this.detailsLists.seekSupplierQuoteDetails.map(item=>{
      //   return item.caterycode
      // })
      // queryPropBrandValuesByClassifyCodes({classifyCodes:arr}).then(res=>{
      //   if (res.data.code=='0'){
      //     this.brandsLists = res.data.data.propBrandNames
      //   }
      // })
    },
    handleGoods(row) {
      this.goodsDialogVisible = true;
      this.goodsSelect = row;
      this.loadBrandOptions(row);
      this.$refs.goodsDialog.getRowLists(
        row,
        this.detailsLists.seekSupplier.supplierId,
        {
          seekId: this.detailsLists.seekId,
          seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId
        }
      );
    },
    handleDialogSubmit(val) {
      this.detailsLists.seekSupplierQuoteDetails = this.detailsLists.seekSupplierQuoteDetails.map(
        item => {
          if (item.skuId === this.goodsSelect.skuId) {
            item.dynamicFields.map(e => {
              if (e.isSkuAttr) {
                item[e.prop] = val[e.prop];
              }
            });
            item.newSkuPropBrand = val.propBrandName;
            item.newSkuName = val.skuName;
            item.newSkuId = val.skuId;
          }
          return item;
        }
      );
      this.goodsDialogVisible = false;
    },
    deleteSkuName(row) {
      this.$confirm("是否确认清空关联商品？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom",
        closeOnClickModal: false
      }).then(() => {
        querySeekDetailBySkuIdForSupplier({
          skuId: row.skuId,
          seekId: this.detailsLists.seekId,
          seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId,
          isShowLoading: true
        }).then(res => {
          if (res.data.code == 0) {
            let arr = res.data.data.seekSupplierQuoteDetails[0];
            this.detailsLists.seekSupplierQuoteDetails = this.detailsLists.seekSupplierQuoteDetails.map(
              item => {
                if (item.skuId === arr.skuId) {
                  item.dynamicFields.map(e => {
                    if (e.isSkuAttr) {
                      console.log(item[e.prop], arr[e.prop]);
                      item[e.prop] = arr[e.prop];
                    }
                  });
                  item.newSkuPropBrand = "";
                  item.newSkuName = "";
                  item.newSkuId = "";
                }
                return item;
              }
            );
          }
        });
      });
    },
    handleDialogCancel() {
      this.goodsDialogVisible = false;
    },
    goGoodsDetail(row) {
      if (row.newSkuName) {
        window.open(
          addUrlPerFix(process.env.VUE_APP_EMI_URL) + "/" + row.skuId
        );
      }
    },
    purchaseBack() {
      this.$router.go(-1);
    },
    filteredOptions(row) {
      if (!this.detailsLists.seekSupplier) {
        return []; // 如果数据尚未加载完成，返回空数组
      }

      const quoteType = this.detailsLists.seekSupplier.quoteType;
      const optionsMap = {
        1: [this.optionButton[0]],
        2: this.detailsLists.isOff === 1 ? [] : [this.optionButton[0]],
        3: this.detailsLists.isOff === 1 ? [] : [this.optionButton[0]]
      };
      return optionsMap[quoteType] || [];
    },
    fixTimeCodeChange(e) {
      switch (e) {
        case 0:
          return "上次支付后";
        case 1:
          return "按月";
        case 2:
          return "按工作日";
        case 3:
          return "指定日期";
        case 4:
          return "按天";
        case 5:
          return "按比例预付款";
        case 6:
          return "全额预付款";
      }
    },
    payTypeChange(e) {
      switch (e) {
        case 0:
          return "发票";
        case 1:
          return "结算";
        case 2:
          return "预付款";
      }
    },
    fixTimeSonCodeChange(fixTimeSonCode) {
      switch (fixTimeSonCode) {
        case 0:
          return "月";
        case 1:
          return "天";
        case 2:
          return "工作日";
      }
    },
    isRetentionMoneyChange(e) {
      return e === 0 ? "质量保证金" : "履约保证金";
    },
    textShow(fixTimeCode, row) {
      switch (fixTimeCode) {
        case 0:
          return this.fixTimeSonCodeChange(row.fixTimeSonCode);
        case 3:
          return "";
        case 5:
          return "";
        default:
          return row.fixTimeSonName;
      }
    },
    payTypeCodeChange(payTypeCodeChange) {
      switch (payTypeCodeChange) {
        case 0:
          return "银行承兑";
        case 1:
          return "商业承兑";
        case 2:
          return "供应链金融";
        case 3:
          return "现金";
      }
    },
    showChange(label, row) {
      if (label === "pricingMethods") {
        return row === 1
          ? "包月"
          : row === 2
          ? "台班"
          : row === 3
          ? "工程量"
          : row === 4
          ? "按天计"
          : row === 5
          ? "按小时计"
          : row === 6
          ? "一口价"
          : row === 7
          ? "项"
          : "-";
      } else if (label === "rentalTime") {
        return row;
      } else {
        if (typeof row === "number" && !isNaN(row)) {
          return row.toFixed(2);
        } else {
          return row;
        }
      }
    },
    accessoryOptions(row) {
      if (!this.detailsLists.seekSupplier) {
        return []; // 如果数据尚未加载完成，返回空数组
      }
      console.log(this.detailsLists.seekSupplier, 123132123);
      // 判断 row.fileName 的尾缀是否是 png、jpg 或 gif
      const hasImageExtension = /\.(png|jpg|gif|pdf)$/i.test(row.fileName);

      // 根据 hasImageExtension 判断是否包括 this.accessoryButton[1]
      const optionsMap = {
        1: [
          this.accessoryButton[0],
          hasImageExtension ? this.accessoryButton[1] : null,
          this.accessoryButton[2]
        ].filter(Boolean), // 移除 null 值
        2:
          this.detailsLists.isOff === 1
            ? [
                this.accessoryButton[0],
                hasImageExtension ? this.accessoryButton[1] : null
              ].filter(Boolean)
            : [
                this.accessoryButton[0],
                hasImageExtension ? this.accessoryButton[1] : null,
                this.accessoryButton[2]
              ].filter(Boolean), // 移除 null 值
        3: [
          this.accessoryButton[0],
          hasImageExtension ? this.accessoryButton[1] : null
        ].filter(Boolean) // 移除 null 值
      };
      return optionsMap[this.detailsLists.seekSupplier.quoteType] || [];
    },
    // handlePurchase(dialogTitle) {
    //   // 检查是否所有项都填写了固定费用和运费
    //   const isComplete = this.detailsLists.seekSupplierQuoteDetails.every(
    //     item => {
    //       // 判断需要校验的列
    //       const requiredColumns = this.tableColumn.filter(col =>
    //         [
    //           "fixedUnitPrice",
    //           "freight",
    //           "taxIncludePrice",
    //           "installFee",
    //           "newSkuPropBrand"
    //         ].includes(col.prop)
    //       );
    //       console.log(requiredColumns, 12313123);
    //
    //       // 遍历必填的列，检查是否有未填的值
    //       const hasIncompleteFields = requiredColumns.some(col => {
    //         const value = item[col.prop];
    //         return value === null || value === undefined || value === ""; // 判断是否未填
    //       });
    //       console.log(hasIncompleteFields, 12313123);
    //
    //       // 判断 finalQuote 是否有效
    //       const isFinalQuoteValid =
    //         item.finalQuote !== null &&
    //         item.finalQuote !== undefined &&
    //         item.finalQuote !== 0 &&
    //         item.finalQuote !== "";
    //       // 如果存在未填字段或 finalQuote 无效，提示错误并返回 false
    //       if (hasIncompleteFields || !isFinalQuoteValid) {
    //         this.$message({
    //           message: "请完善报价信息",
    //           type: "error",
    //           duration: 3000,
    //           ccuiCustom: true,
    //           showClose: true
    //         });
    //         return false;
    //       }
    //       // 如果所有校验通过，返回 true
    //       return true;
    //     }
    //   );
    //
    //   // 如果没有完整填写，停止执行
    //   if (!isComplete) return;
    //
    //   // 如果标题是 "提交报价"，显示对话框并更改标题
    //   if (dialogTitle === "提交报价") {
    //     this.dialogTitle = "库存预警";
    //     querySeekSkuForSupplier({
    //       seekId: this.detailsLists.seekId,
    //       seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId,
    //       isShowLoading: true
    //     }).then(res => {
    //       if (res.data.code === "0") {
    //         if (res.data.data.isShow) {
    //           this.dialogVisible = true;
    //           this.seekSkuReqBOList = res.data.data.seekSkuRspBOList;
    //         } else {
    //           this.dialogTitle = "报价确认";
    //           this.dialogVisible = true;
    //         }
    //       }
    //     });
    //   }
    // },
    handlePurchase(dialogTitle) {
      // 检查是否所有项都填写了固定费用、运费、报价品牌等
      const isComplete = this.detailsLists.seekSupplierQuoteDetails.every(
        item => {
          // 判断需要校验的列
          const requiredColumns = this.tableColumn.filter(col =>
            [
              "fixedUnitPrice",
              "freight",
              "taxIncludePrice",
              "installFee"
            ].includes(col.prop)
          );

          // 遍历必填的列，检查是否有未填的值
          const hasIncompleteFields = requiredColumns.some(col => {
            const value = item[col.prop];
            return value === null || value === undefined || value === "";
          });

          // 校验报价品牌
          const isBrandValid =
            item.newSkuPropBrand !== null &&
            item.newSkuPropBrand !== undefined &&
            item.newSkuPropBrand !== "";

          // 校验 finalQuote
          const isFinalQuoteValid =
            item.finalQuote !== null &&
            item.finalQuote !== undefined &&
            item.finalQuote !== 0 &&
            item.finalQuote !== "";

          // 如果有未填项，提示错误并返回 false
          if (hasIncompleteFields || !isFinalQuoteValid || !isBrandValid) {
            this.$message({
              message: "请完善报价信息",
              type: "error",
              duration: 3000,
              ccuiCustom: true,
              showClose: true
            });
            return false;
          }

          // 如果所有校验通过
          return true;
        }
      );

      // 如果有不完整的，停止执行
      if (!isComplete) return;

      // 提交逻辑
      if (dialogTitle === "提交报价") {
        this.dialogTitle = "库存预警";
        querySeekSkuForSupplier({
          seekId: this.detailsLists.seekId,
          seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            if (res.data.data.isShow) {
              this.dialogVisible = true;
              this.seekSkuReqBOList = res.data.data.seekSkuRspBOList;
            } else {
              this.dialogTitle = "报价确认";
              this.dialogVisible = true;
            }
          }
        });
      }
    },
    dialogSubmit(title) {
      if (title === "库存预警") {
        this.dialogVisible = false;
        setTimeout(() => {
          this.dialogTitle = "报价确认";
          this.dialogVisible = true;
        }, 300);
      } else if (title === "报价确认") {
        let arr = {
          seekId: this.detailsLists.seekId, //询价单主键id
          seekCode: this.detailsLists.seekCode, //询价单编号
          seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId, //报名供货商主键id
          quoteDescription: this.detailsLists.seekSupplier.quoteDescription,
          seekFileBOList: this.detailsLists.seekFiles, //附件IP地址
          seekSupplierQuoteDetailsBOList: this.detailsLists
            .seekSupplierQuoteDetails
        };

        supplierQuote({ ...arr, isShowLoading: true }).then(res => {
          if (res.data.code === "0") {
            this.dialogVisible = false;
            this.$message({
              showClose: true,
              message: `报价成功`,
              type: "success",
              ccuiCustom: true
            });
            this.$router.go(-1);
          }
        });
      }
    },
    tabChange(item) {
      this.tabShow = item.value;
      localStorage.setItem("currentTab", item.value);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      // 获取最后一列的索引
      const lastColumnIndex = columns.length - 1;

      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = {
            text: "报价总金额（CNY_人民币）",
            isRed: true
          };
          return;
        }

        if (index === lastColumnIndex) {
          const values = data.map(item => {
            const value = Number(item[column.property]);
            return isNaN(value) ? 0 : value; // 确保每个值都是数字
          });
          sums[index] = {
            text: values.reduce((prev, curr) => prev + curr, 0).toFixed(2) // 计算总和
          };
          this.aggregateAmount = sums[index].text;
        } else {
          sums[index] = { text: "" }; // 其他列的合计为空
        }
      });

      return sums;
    },
    handleRemove(file, fileList) {},
    uploadHandler(res, file, fileList) {
      this.$message.closeAll();
      this.$message({
        showClose: true,
        message: `附件上传成功`,
        type: "success",
        ccuiCustom: true
      });
      this.uploadLoading.close();
      let fileData = res.data[0];
      this.detailsLists.seekFiles.push({
        uploadId: fileData.uploadId,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024) + "kb",
        createTime: fileData.createTime,
        fileUrl: fileData.downloadUrl
      });
      // this.enterpriseRuleForm.submitFileInfoBO.uploadIds = []
      // this.tableData.forEach((item) => {
      //   this.enterpriseRuleForm.submitFileInfoBO.uploadIds.push(item.uploadId)
      // })
    },
    uploadError(res, file, fileList) {
      if (res.code != "0") {
        this.$message.closeAll();
        this.$message({
          showClose: true,
          type: "error",
          ccuiCustom: true,
          message: res.message
        });
      }
    },
    beforeUpload(file) {
      const isLt15 = file.size < 15728640;
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const extension =
        testmsg === "xls" ||
        testmsg === "xlsx" ||
        testmsg === "jpg" ||
        testmsg === "docx" ||
        testmsg === "doc" ||
        testmsg === "pdf" ||
        testmsg === "png" ||
        testmsg === "bmp" ||
        testmsg === "jpeg";
      if (!isLt15) {
        this.$message({
          showClose: true,
          message: "文件大小不超过15M!",
          type: "error",
          ccuiCustom: true,
          duration: 0
        });
      }
      if (!extension) {
        this.$message({
          showClose: true,
          message:
            "上传文件只能是 pdf、doc、docx、xls、xlsx、jpg、jpeg、png、bmp格式!",
          type: "error",
          ccuiCustom: true,
          duration: 0
        });
      }
      return isLt15 && extension;
    },
    onProgress(progressEvent) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    startCountdown() {
      const endTime = new Date(this.detailsLists.seekOffTime).getTime();
      this.intervalId = setInterval(() => {
        this.calculateTime(endTime);
      }, 1000);
    },
    calculateTime(endTime) {
      const now = new Date().getTime();
      const timeDiff = endTime - now;

      if (timeDiff <= 0) {
        clearInterval(this.intervalId);
        this.remainingTime = { hours: "00", minutes: "00", seconds: "00" };
        return;
      }

      const totalHours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.remainingTime.hours = String(totalHours).padStart(2, "0");
      this.remainingTime.minutes = String(minutes).padStart(2, "0");
      this.remainingTime.seconds = String(seconds).padStart(2, "0");
    },
    handleClick(row, value) {
      if (value === 1) {
        let openUrl = document.createElement("a");
        openUrl.style.display = "none";
        openUrl.href =
          `${addUrlPerFix(
            process.env.VUE_APP_BASE_URL
          )}/apis/ebs/uploadFile/downloadByUrl?downloadUrl=${
            row.fileUrl
          }&fileName=` + encodeURIComponent(row.fileName);
        openUrl.setAttribute("download", row.fileName);
        console.log(openUrl, "openUrl");
        document.body.appendChild(openUrl);
        openUrl.click();
      } else if (value === 2) {
        window.open(row.fileUrl, "_blank");
      } else {
        const index = this.detailsLists.seekFiles.indexOf(row);
        if (index > -1) {
          // 从数组中删除当前行
          this.detailsLists.seekFiles.splice(index, 1);
        }
      }
    },
    // allowOnlyNumbersAndDecimals(event) {
    //   const allowedKeys = [
    //     "Backspace", "Delete", "ArrowLeft", "ArrowRight", // 功能键
    //     "Tab", "-", ".",                                  // 特殊符号
    //     ...Array.from({ length: 10 }, (_, i) => `${i}`)   // 数字键
    //   ];
    //
    //   if (!allowedKeys.includes(event.key)) {
    //     event.preventDefault(); // 阻止非法字符输入
    //   }
    // },
    isInputDis(row, header) {
      const field = row.dynamicFields.find(item => header === item.prop);
      return field ? field.isEditable : false;
    },
    isSkuAttr(row, header) {
      const field = row.dynamicFields.find(item => header === item.prop);
      return field ? !field.isSkuAttr : false;
    },
    isInputExist(row, header) {
      const field = row.dynamicFields.find(item => header === item.prop);
      return field ? field.isExist : false;
    },

    handleInput(row, prop) {
      let value = row[prop];

      const allowNegative = prop === "otherFees" || prop === "fixedUnitPrice";
      const numberPattern = allowNegative
        ? /^-?\d*(\.\d{0,2})?$/ // 允许负数
        : /^\d*(\.\d{0,2})?$/; // 不允许负数

      // 移除非数字和小数点的非法字符（包括负号，如果不允许负数）
      value = value.replace(allowNegative ? /[^0-9.-]/g : /[^0-9.]/g, "");

      // 检查是否有多个小数点
      const dotCount = (value.match(/\./g) || []).length;
      if (dotCount > 1) {
        // 如果有多个小数点，保留第一个并删除其余的
        value = value
          .split(".")
          .slice(0, 2)
          .join(".");
      }

      // 如果允许负数，检查负号的位置（只能在最前面）
      if (allowNegative && value.indexOf("-") > 0) {
        value = "-" + value.replace(/-/g, "");
      }

      // 校验是否为非法的零开头（如 "012123"）
      if (/^0\d/.test(value)) {
        // 自动转换为合法的 "0.xxx" 格式
        value = `0.${value.slice(1)}`;
      }

      // 校验是否符合数字格式
      if (!numberPattern.test(value)) {
        // 如果只输入了小数点，自动补全为 "0."
        if (value === ".") {
          value = "0.";
        }
        // 如果包含非法字符，删除最后一个非法字符
        else {
          value = value.slice(0, -1);
        }
      }

      // 最终更新 row[prop] 的值
      row[prop] = value;
    },
    handleBlur(row, prop) {
      if (prop === "finalQuote") {
        // 检查输入是否为空或无效
        if (row[prop] === undefined || row[prop] === null || row[prop] === "") {
          return false;
        }
        getShowFinalQuotePrice(row).then(res => {
          if (res.data.code === "0") {
            const responseObject = res.data.data;

            // 遍历返回对象，将值合并到 row 中
            Object.keys(responseObject).forEach(key => {
              row[key] = responseObject[key];
            });
          }
        });
      } else {
        // 检查输入是否为空或无效
        if (row[prop] === undefined || row[prop] === null || row[prop] === "") {
          return false;
        }
        getShowPrice({
          ...row,
          sourceSystem: this.detailsLists.sourceSystem
        }).then(res => {
          if (res.data.code === "0") {
            const responseObject = res.data.data;

            // 遍历返回对象，将值合并到 row 中
            Object.keys(responseObject).forEach(key => {
              row[key] = responseObject[key];
            });
          }
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    numberToChinese(num) {
      // 金额超出范围的处理
      if (num === 0 || !num) return "零元整";
      if (num > 9999999999999.99) return "金额超出范围";

      const cnNums = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      ];
      const cnIntRadice = ["", "拾", "佰", "仟"];
      const cnIntUnits = ["", "万", "亿", "兆"];
      const cnDecUnits = ["角", "分"];
      const cnInteger = "整";
      const cnIntLast = "元";

      let integerNum; // 整数部分
      let decimalNum; // 小数部分
      let chineseStr = ""; // 转换后的大写中文字符串
      let parts; // 数字分段

      // 将数值保留两位小数并分割成整数和小数部分
      num = parseFloat(num).toFixed(2);
      parts = num.split(".");
      integerNum = parts[0];
      decimalNum = parts[1];

      // 转换整数部分
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        const intLen = integerNum.length;
        for (let i = 0; i < intLen; i++) {
          const n = integerNum.charAt(i);
          const p = intLen - i - 1;
          const q = Math.floor(p / 4);
          const m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            zeroCount = 0; // 归零
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }

      // 转换小数部分
      if (decimalNum !== "00") {
        for (let i = 0; i < decimalNum.length; i++) {
          const n = decimalNum.charAt(i);
          if (n !== "0") {
            chineseStr += cnNums[parseInt(n)] + cnDecUnits[i];
          }
        }
      } else {
        chineseStr += cnInteger;
      }

      return chineseStr;
    }
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("currentTab");
    next();
  }
};
</script>

<style lang="scss" scoped>
.detail-info {
  margin-top: 20px;
  width: 100%;
  background: #fff;
  padding-bottom: 150px;
}

.tab {
  height: 20px;
  color: #4a4a4a;
  background: #ebebeb;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}

.table-top-active {
  background: #fff;
  color: #0089ef;
  font-weight: 500;
}

.bodyText {
  font-weight: 400;
  font-size: 13px;
  color: #4a4a4a;
  margin-bottom: 20px;
}

.bodyTextPadding {
  margin-right: 30px;
}

/deep/ .el-table td,
.el-table th {
  padding: 0;
}

/deep/ .el-table th,
.el-table tr:first-child {
  .cell {
    padding: 3px 5px;
  }
}

/deep/ .el-table .cell {
  //padding: 18px 5px;
}

/deep/ .el-table thead {
  font-size: 13px;
}

.quotation {
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 80px;
  top: 0;

  .time {
    > span {
      font-size: 18px;
      color: #ff142f;
      display: inline-block;
      font-weight: 500;
      margin: 10px;
      align-items: flex-end;
    }
  }
}

/deep/ .el-table__footer-wrapper tr td:nth-child(2) {
  color: #ff142f;
}

/deep/ .el-table__fixed-footer-wrapper tr td:last-child {
  color: #ff142f;
  background: #fff;
  font-weight: bold;
  font-size: 15px;
}

/deep/ .el-table__fixed-footer-wrapper tr td:first-child {
  background: #fff;
}

/deep/ .el-table__fixed-footer-wrapper tbody td {
  color: #ff142f;
}

/deep/ .el-table__footer-wrapper tbody td {
  background: #fff;
}

/deep/ .el-table th {
  padding: 3px 0 !important;
}

/deep/ .el-table td {
  padding: 3px 0 !important;
}

/deep/ .el-table__row {
  font-size: 13px;
}

///deep/.el-table__footer-wrapper tr:last-child {
//  td{
//    border-right: none;
//
//  }
//}

.dialogBody {
  div {
    margin-bottom: 5px;
  }
}

.pitchOn {
  background: green;
  color: white;
}

.unchecked {
  background: red;
  color: white;
}

.info-item {
  display: flex;
  //align-items: center;  // 保证垂直方向上对齐
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 20px;
  word-wrap: break-word; // 自动换行，防止文本内容挤压
}

.label {
  display: inline-block;
  width: 110px; // 固定宽度
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0; // 防止label被压缩
}

.info-item > span {
  white-space: normal; // 允许文本换行
  word-wrap: break-word; // 遇到长单词时进行换行
  overflow-wrap: break-word; // 同样处理单词溢出
  word-break: break-all; // 防止长单词在容器之外溢出，尽量拆分长单词
  text-overflow: ellipsis; // 当文本超出时显示省略号（可选）
  overflow: hidden; // 防止溢出
}

/deep/ .el-col-24 {
  width: 85% !important;
}

.goodsDetail {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}

.newSkuNameGo {
  color: #ff142f;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
}

.blodText {
  color: #ff142f;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
}
.fineText {
  cursor: pointer;
}
.headerBlod {
  font-weight: bolder;
}
</style>
